
import {FormInput} from 'shards-react';
import React,{Component} from "react";





export default class TimePicker  extends Component{
  render(){
    return (
        <form style={{display: 'flex',flexWrap: 'wrap',}} noValidate>
            <FormInput
              id="time"
              type="time"
              defaultValue="00:00"
              style={{ width: "100%",}}
              InputLabelProps={{
                        shrink: true,
                      }}
              inputProps={{
                  step: 300, // 5 min
              }}
            onChange={this.props.onChange}
          />
      </form>
    );
  }
}

